import {differenceInCalendarDays} from "date-fns";
import { getCaptchaAppId, validImgCode } from "@/api/user";

export function unique(arr, key = 'id') {
  const res = new Map();
  if (key == null) {
    return Array.from(new Set(arr));
  } else if (typeof key === 'string') {
    return arr.filter((a) => !res.has(a[key]) && res.set(a[key], 1));
  } else {
    const keys = key;
    return arr.filter((a) => {
      const v = combineByKeys(a, keys, (e1, e2) => `${e1}_${e2}`);
      return !res.has(v) && res.set(v, 1);
    });
  }
}

export function combineByKeys(obj, keys, fn) {
  return keys.reduce((k1, k2) => fn(obj[k1], obj[k2]));
}
/** 判断对象是否有意义 */
export function isMeaningful(obj, callBack) {
  const meaningful = obj !== null && obj !== undefined && obj !== '';
  if (meaningful && callBack) {
    callBack();
  }
  return meaningful;
}
/** 判断对象是否有意义 取反 */
export function isMeaningless(obj, callBack) {
  return !isMeaningful(obj, callBack);
}

export function meaningfulEq(e1, e2) {
  return isMeaningful(e1) && isMeaningful(e2) && e1 === e2;
}

export function isEmptyArr(arr) {
  return !isMeaningful(arr) || arr.length === 0;
}
/**
 * 三元判断  如果对象有意义 使用对用原对象 如果无意义 则使用传过来的默认值
 * @param {*} obj 原对象
 * @param {*} defaultV 传入职 默认为null
 * @example
 * defaultVal(null,a) = a
 * 类似 obj = null || a 结果为
 */
export function defaultVal(obj, defaultV = null) {
  return isMeaningful(obj) ? obj : defaultV;
}

export function addPx(px1, px2) {
  return `${Number(px1.replace('px', '')) + Number(px2.replace('px', ''))}px`;
}

export function subPx(px1, px2) {
  return `${Number(px1.replace('px', '')) - Number(px2.replace('px', ''))}px`;
}

export function isBlank(str) {
  return str === null || str === undefined || str === '' || str === 'null';
}

export function isNotBlank(str) {
  return !isBlank(str);
}

/**
 * @description 映射转换，转换成 [object, object2] => {id： object, id2： object2} 形式;
 * @param options: 需要转换的数组
 * @param key 键值对的键
 */
export function transformToMap(options, key = 'id') {
  const obj = {};
  if (options && options.length) {
    for (const item of options) {
      obj[item[key]] = item;
    }
    return obj;
  } else {
    return {};
  }
}

/**
 * @description 对象转字符串，导出处理
 * @param params
 */
export function queryParamsMap(params) {
  let strs = '';
  for (const attr in params) {
    if (isMeaningful(params[attr])) {
      strs += (attr + '=' + params[attr] + '&');
    }
  }
  return strs.slice(0, -1);
}

export function countryMarketParams(countryMarket, options = {countryKey: 'countrys', marketKey: 'marketIds', type: 'string'}) {
  const params = {};
  if (isMeaningful(countryMarket)) {
    if (isMeaningful(countryMarket.countryIds) && countryMarket.countryIds.length > 0) {
      if (options.type === 'string') {
        params[options.countryKey] = countryMarket.countryIds.join(',');
      } else {
        params[options.countryKey] = countryMarket.countryIds;
      }
    }
    if (isMeaningful(countryMarket.marketIds) && countryMarket.marketIds.length > 0) {
      if (options.type === 'string') {
        params[options.marketKey] = countryMarket.marketIds.join(',');
      } else {
        params[options.marketKey] = countryMarket.marketIds;
      }
    }
  }
  return params;
}

export function doNothing() {}

export function disabledEndDate(startDate = new Date()) {
  return (current) => {
    if (typeof startDate === 'string') {
      startDate = new Date(startDate);
    }
    return differenceInCalendarDays(current, startDate) < 0;
  };
}

// export function viewChildren(component, tagName) {
//   const childrenComponent = [];
//   for (let i = 0; i < component.$children.length; i++) {
//     const child = component.$children[i];
//     if (child.$options['_componentTag'] === tagName) {
//       childrenComponent.push();
//     }
//   }
// }

export function splitAndUnique(str, split = /\n/, key = null) {
  const splitStr = split.toString().replace(/^(\/)+|(\/)+$/g, '');
  const re0 = new RegExp(`^${splitStr}*|${splitStr}*$`);
  const re1 = new RegExp(`${splitStr}+`);
  const arr = str.split(split)
    .map(item => item.replace(re0, '').trim())
    .filter(item => isMeaningful(item) && !re1.test(item));
  return unique(arr, key);
}

export function identityArray(arr1, arr2) {
  if (isBlank(arr1) && isBlank(arr2)) {
    return true;
  }
  if (isBlank(arr1) && isNotBlank(arr2)) {
    return false;
  }
  if (isNotBlank(arr1) && isBlank(arr2)) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  const tempArr1 = [...arr1];
  const tempArr2 = [...arr2];
  tempArr1.sort();
  tempArr2.sort();
  for (let i = 0; i < tempArr1.length; i++) {
    if (tempArr1[i] !== tempArr2[i]) {
      return false;
    }
  }
  return true;
}

export function toFixed(num, n = 2) {
  if (isMeaningless(num) || isNaN(num)) {
    return null;
  }
  const pow = Math.pow(10, n);
  return Math.round(num * pow) / pow;
}

// objType: 'base' | 'amount'
export function sumField(values, objName, decimalNumber = null, objType = 'base') {
  if (!isBlank(values)) {
    if (objType === 'amount') {
      return {
        currencySymbol: values[0][objName].currencySymbol,
        currencyAmount: toFixed(values
          .map(item => item[objName])
          .map(item => item.currencyAmount)
          .reduce((e1, e2) => e1 + e2, 0), decimalNumber)
      };
    }
    if (decimalNumber) {
      return Number(toFixed(values.filter(item => !isNaN(Number(item[objName])))
        .map(item => Number(item[objName]))
        .reduce((e1, e2) => e1 + e2, 0), decimalNumber));
    }
    return values.filter(item => !isNaN(Number(item[objName])))
      .map(item => Number(item[objName]))
      .reduce((e1, e2) => e1 + e2, 0);
  } else {
    return 0;
  }
}

export function isNumber(val) {
  return parseFloat(val).toString() !== 'NaN';
}

export function generateUUID() {
  let d = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

export function type(obj) { return typeof obj !== "object" ? typeof obj : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase(); }

/**
 * @description 类型判断，返回布尔值
 * @param params 需要判断的数据
 * @param type 需要判断的类型
 */
export function isType(params, type) {
  return Object.prototype.toString.call(params) === `[object ${type}]`
}

export const findComponentDownward = (context, componentName) => {
  const childrens = context.$children;
  let children = null;

  if (childrens.length) {
    for (const child of childrens) {
      const name = child.$options.name;

      if (name === componentName) {
        children = child;
        break;
      } else {
        children = findComponentDownward(child, componentName);
        if (children) break;
      }
    }
  }
  return children;
}

/**
 * @description 腾讯图形验证码
 * @param bizState 自定义参数
 */
export const tcAuthCode = bizState => {
  return new Promise((resolve, reject) => {
    getCaptchaAppId().then(CaptchaAppId => {
      if (CaptchaAppId) {
        const captcha = new TencentCaptcha(CaptchaAppId, res => {
          if (res.ret === 0) {
            validImgCode({ ticket: res.ticket, randstr: res.randstr, phone: bizState }).then(data => {
              data && resolve(data)
              reject()
            })
          } else {
            reject()
          }
        }, { bizState, needFeedBack: false })
        captcha.initOpts.forceLang = 'zh-cn' //  多语言调用
        captcha.langFun()
        captcha.show()
      }
    })
  })
}

/**
 * @description 腾讯图形验证码
 * @param bizState 自定义参数
 */
export const tcAuthCodeFreeCheck = bizState => {
  return new Promise((resolve, reject) => {
    getCaptchaAppId().then(CaptchaAppId => {
      if (CaptchaAppId) {
        const captcha = new TencentCaptcha(CaptchaAppId, res => {
          console.log(res);
          if (res.ret === 0) {
            validImgCode({ ticket: res.ticket, randstr: res.randstr, phone: bizState, loginType: 'WEB' }).then(data => {
              data && resolve(data)
              reject()
            })
          } else {
            reject()
          }
        }, { bizState, needFeedBack: false })
        captcha.initOpts.forceLang = 'zh-cn' //  多语言调用
        captcha.langFun()
        captcha.show()
      }
    })
  })
}


/**
 * @description 汇率转换
 * @param value 金额
 * @param key1 设置币种
 * @param key2 目标币种
 * @param map 汇率
 */

 export const currencyToTargetCurrency = (value, key1, key2, map)=> {
  return (!value ||  !key1 || !key2 || !map[key1] ||  !map[key2]) ? 0 : (value * map[key1] / map[key2])
}